import request from "./http";
import qs from 'qs'

//首页获取建筑信息下拉
// 
export function findAreaList() {
    return request({
        url: "/area/findAreaList",
        method: "get",
    });
}
//首页获取建筑信息
// 
export function findEnergyBuildingInfoById(params) {
    return request({
        url: "/building/findEnergyBuildingInfoById",
        method: "get",
        params
    });
}
//建筑信息页获取建筑类型
// 
export function findAllBuildingType() {
    return request({
        url: "/energyBuilding/findAllBuildingType.do",
        method: "get",
    });
}
//新增建筑信息
export function saveEnergyBuildingInfo(params) {
    return request({
        url: "/building/saveEnergyBuildingInfo",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params

    });
}
//获取建筑信息页列表
// 
export function findBuildingByNameAndNo(params) {
    return request({
        url: "/building/findBuildingByNameAndNo",
        method: "get",
        params
    });
}
//删除建筑信息页列表
// 
export function deleteEnergyBuildingInfoById(params) {
    return request({
        url: "/building/deleteEnergyBuildingInfoById",
        method: "delete",
        params
    });
}


//建筑类型列表查询
// 参数  有参数就是搜索查询  无参数就是默认全部
export function GetEnergyBuildingType(params) {
    return request({
        url: "/energyBuilding/findBuildingTypePage.do",
        method: "get",
        params,
    });
}

//新增建筑类型
// export function saveBuildingType(params) {
//     return request({
//         url: "/energyBuilding/saveBuildingType.do",
//         method: "post",
//         headers:{
//             'Content-Type':'application/x-www-form-urlencoded',
//             'Accept':'*/*'
//           },
//         data:qs.stringify(params)

//     });
// }
export function saveBuildingType(data) {
    return request({
        url: "/energyBuilding/saveBuildingType.do",
        method: "post",
        data
    });
}

//删除
// 参数  typeIds
export function deleteBuildingTypeByIds(params) {
    return request({
        url: "/energyBuilding/deleteBuildingTypeByIds.do",
        method: "delete",
        params,
    });
}

// 参数 unitId 
//获取单位下抄表设备列表
export function getMeterReadingConfigListByUnitId(data) {
    return request({
      url: "/meterReading/getMeterReadingConfigListByUnitId.do",
      method: "post",
      headers:{
        'Content-Type':'application/x-www-form-urlencoded',
        'Accept':'*/*'
       },
      data,
    });
  }
  
//根据区域Id查看区域中的变压器以及数量
// 参数  areaId 区域id
export function getTransformerByAreaId(params) {
    return request({
        url: "/building/getTransformerByAreaId",
        method: "get",
        params,
    });
}
